export const locales  = ['en', 'fr'];
export const isInLocales = locale => locales.includes(locale)